export default function addMorePosts(){
    $("#addPostsbtn").on('click', function () {
        let page = $(this).attr('page');
        $.ajax({
            type: "POST",
            url: '?page=' + page,
            headers: {
                'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
            },
            dataType: 'html',
            success: function (posts) {
                let postCount = $(posts).find(".card").length;
                if (posts) {
                    $(posts).appendTo(".add-posts");
                    page++
                    $("#addPostsbtn").attr('page', page);
                } 
                
                if (!posts || postCount < 3) {
                    $("#addPostsbtn").remove();
                }
            }
        });
    });
}
